// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-selector{align-self:end}body.body--popup-open{overflow:hidden !important}", ""]);
// Exports
module.exports = exports;
